import {
  RESET_FLASH_MSGS,
  RESET_FLASH_MSG,
  RESET_ERROR,
  GET_FLASH_MSGS,
  SET_FLASH_MSGS,
  API_ERROR,
  GET_FLASH_MSG,
  SET_FLASH_MSG,
  CREATE_FLASH_MSG,
  CREATE_FLASH_MSG_SUCCESS,
  EDIT_FLASH_MSG,
  EDIT_FLASH_MSG_SUCCESS,
  DELETE_FLASH_MSG,
  DELETE_FLASH_MSG_SUCCESS,
} from "./actionTypes";

export const resetFlashMsgs = () => {
  return {
    type: RESET_FLASH_MSGS,
    payload: {},
  };
};

export const resetFlashMsg = () => {
  return {
    type: RESET_FLASH_MSG,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getFlashMsgs = () => {
  return {
    type: GET_FLASH_MSGS,
    payload: {},
  };
};
export const setFlashMsgs = (data) => {
  return {
    type: SET_FLASH_MSGS,
    payload: { ...data },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createFlashMsg = (newFlashMsgValues) => {
  return {
    type: CREATE_FLASH_MSG,
    payload: { newFlashMsgValues },
  };
};
export const createFlashMsgSuccess = (data) => {
  return {
    type: CREATE_FLASH_MSG_SUCCESS,
    payload: { data },
  };
};

export const getFlashMsg = (idFlashMsg) => {
  return {
    type: GET_FLASH_MSG,
    payload: { idFlashMsg },
  };
};
export const setFlashMsg = (data) => {
  return {
    type: SET_FLASH_MSG,
    payload: { data },
  };
};

export const editFlashMsg = (idFlashMsg, newFlashMsgValues) => {
  return {
    type: EDIT_FLASH_MSG,
    payload: {
      idFlashMsg,
      newFlashMsgValues,
    },
  };
};
export const editFlashMsgSuccess = (message) => {
  return {
    type: EDIT_FLASH_MSG_SUCCESS,
    payload: { message },
  };
};

export const deleteFlashMsg = (idFlashMsg, idCompany) => {
  return {
    type: DELETE_FLASH_MSG,
    payload: { idFlashMsg, idCompany },
  };
};
export const deleteFlashMsgSuccess = (message) => {
  return {
    type: DELETE_FLASH_MSG_SUCCESS,
    payload: { message },
  };
};
